// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconMagnifyingGlass = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M55.3455 49.6887L49.6887 55.3455C48.816 56.2181 47.7329 56.2182 46.8602 55.3455L38.6545 47.1397C37.7819 46.2672 37.7819 45.1839 38.6545 44.3113L39.3616 43.6042L36.8182 41.0609C33.9402 42.9622 30.2888 44 26 44C14.8933 44 8 37.1066 8 26C8 14.8932 14.8933 8 26 8C37.1067 8 44 14.8932 44 26C44 30.2888 42.9622 33.9402 41.0609 36.8182L43.6042 39.3616L44.3113 38.6544C45.184 37.7818 46.2672 37.7818 47.1398 38.6544L55.3455 46.8602C56.2181 47.7329 56.2181 48.816 55.3455 49.6887ZM26 38C33.4045 38 38 33.4044 38 26C38 18.5955 33.4045 14 26 14C18.5955 14 14 18.5955 14 26C14 33.4044 18.5955 38 26 38Z" />
    </svg>
  );
};
